import React from 'react';
import {FaFacebookF, FaTwitter, FaGithub, Fa500Px, FaLinkedinIn} from 'react-icons/fa';
import Typical from 'react-typical';




const Baner = () => {
    const [state] = React.useState({title:'Saami U Karim', text: 'I am Saami, a proffessional web developer also an enthusiast photographer', image:"https://i.ibb.co/Q8NK8gb/Pics-Art-06-21-12-13-55.png" })
    return (
        
        <header className="headerr">
            <div className="containerr">
                <div className="roww">
                    <div data-aos="fade-right" className="coll-6 ">
                        <div className="header-content">
                            <div className="header-section">
                            <ul className="header-ul">
                                <li>
                                    
                                   <a href="https://www.facebook.com/saamiu.karim.92/" t>
                                    <FaFacebookF color="white" ></FaFacebookF>
                                    </a>
                                    
                                    
                                </li>
                                <li>
                                    <a href="https://mobile.twitter.com/saami_u">
                                    <FaTwitter color="white"></FaTwitter></a>
                                </li>
                                <li>
                                    <a href="https://github.com/saamiukarim">
                                <FaGithub color="white"></FaGithub>
                                </a>
                                </li>
                                <li>
                                    <a href="https://500px.com/p/saamiukarim1?view=photos">
                                <Fa500Px color="white"></Fa500Px>
                                </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/in/saami-u-karim-66a436215/">
                                <FaLinkedinIn color="white"></FaLinkedinIn>
                                </a>
                                </li>
                            </ul>
                            <h1>{state.title}</h1>
                            <p><Typical loop={Infinity}
                            wrapper="b"
                            steps={['Web Designer',1000,'Web Developer',1000, 'Photographer', 1000,'Brother',1000,'Son',1000]}
                            />
                            </p>
                            
                            </div>
                           
                        </div>

                    </div>
                    <div data-aos="fade-left" className="coll-6">
                        <div className="banner-img">
                        {/* <img src="../images/PicsArt_06-21-01.16.13.jpg"/> */}
                        <img src={state.image} border="0"/>
                        </div>

                    </div>
                </div>
            </div>
        

        </header>
    
        
    );
};

export default Baner;